import { useTranslation } from 'react-i18next'

import { z } from '@/lib/zod'

export function NewPasswordSchema() {
  const { t } = useTranslation('login')

  return z
    .object({
      password: z.string().nonempty(),
      confirmPassword: z.string().nonempty(),
    })
    .refine((data) => data.password === data.confirmPassword, {
      message: t('forgot_password.new_password.errors.passwords_do_not_match'),
      path: ['confirmPassword'],
    })
}

export type NewPasswordForm = z.infer<ReturnType<typeof NewPasswordSchema>>
